"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/stats/v1/stats.proto
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsServiceClient = exports.AllResponse_XirrMiiProvisionByThematicEntry = exports.AllResponse_ProjectCountByThematicEntry = exports.AllResponse_CollectedAmountSumByThematicEntry = exports.AllResponse_CollectedAmountSumByCountryEntry = exports.AllResponse_CollectedAmountSumByRegionEntry = exports.AllResponse_ProjectCountByCountryEntry = exports.AllResponse_ProjectCountByRegionEntry = exports.AllResponse_ProjectCountByCategoryEntry = exports.AllResponse = exports.Interval = exports.AllRequest_OnlyFieldsEntry = exports.AllRequest = exports.ComputeResponse_ProjectsNumberByCategoryEntry = exports.ComputeResponse_ProjectsNumberByRegionEntry = exports.ComputeResponse = exports.ComputeRequest = exports.interval_TypeToJSON = exports.interval_TypeFromJSON = exports.Interval_Type = void 0;
/* eslint-disable */
var collect_1 = require("../../common/v1/collect");
var health_1 = require("../../common/v1/health");
exports.Interval_Type = {
    TYPE_UNSPECIFIED: "TYPE_UNSPECIFIED",
    TYPE_DAY: "TYPE_DAY",
    TYPE_MONTH: "TYPE_MONTH",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function interval_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return exports.Interval_Type.TYPE_UNSPECIFIED;
        case 1:
        case "TYPE_DAY":
            return exports.Interval_Type.TYPE_DAY;
        case 2:
        case "TYPE_MONTH":
            return exports.Interval_Type.TYPE_MONTH;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.Interval_Type.UNRECOGNIZED;
    }
}
exports.interval_TypeFromJSON = interval_TypeFromJSON;
function interval_TypeToJSON(object) {
    switch (object) {
        case exports.Interval_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case exports.Interval_Type.TYPE_DAY:
            return "TYPE_DAY";
        case exports.Interval_Type.TYPE_MONTH:
            return "TYPE_MONTH";
        case exports.Interval_Type.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.interval_TypeToJSON = interval_TypeToJSON;
function createBaseComputeRequest() {
    return {};
}
exports.ComputeRequest = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.ComputeRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseComputeRequest();
        return message;
    },
};
function createBaseComputeResponse() {
    return {
        project_count: 0,
        average_interest_rate: 0,
        projects_success_rate: 0,
        total_collected_amount: "0",
        total_repaid_amount: 0,
        lenders_count: 0,
        legal_pledges_rate: 0,
        projects_number_by_region: {},
        projects_number_by_category: {},
        average_collected_amount: 0,
        average_collect_duration: 0,
        average_repay_term: 0,
        average_pledge_amount: 0,
        late_term_rate: 0,
        default_term_rate: 0,
    };
}
exports.ComputeResponse = {
    fromJSON: function (object) {
        return {
            project_count: isSet(object.project_count) ? globalThis.Number(object.project_count) : 0,
            average_interest_rate: isSet(object.average_interest_rate) ? globalThis.Number(object.average_interest_rate) : 0,
            projects_success_rate: isSet(object.projects_success_rate) ? globalThis.Number(object.projects_success_rate) : 0,
            total_collected_amount: isSet(object.total_collected_amount)
                ? globalThis.String(object.total_collected_amount)
                : "0",
            total_repaid_amount: isSet(object.total_repaid_amount) ? globalThis.Number(object.total_repaid_amount) : 0,
            lenders_count: isSet(object.lenders_count) ? globalThis.Number(object.lenders_count) : 0,
            legal_pledges_rate: isSet(object.legal_pledges_rate) ? globalThis.Number(object.legal_pledges_rate) : 0,
            projects_number_by_region: isObject(object.projects_number_by_region)
                ? Object.entries(object.projects_number_by_region).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            projects_number_by_category: isObject(object.projects_number_by_category)
                ? Object.entries(object.projects_number_by_category).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            average_collected_amount: isSet(object.average_collected_amount)
                ? globalThis.Number(object.average_collected_amount)
                : 0,
            average_collect_duration: isSet(object.average_collect_duration)
                ? globalThis.Number(object.average_collect_duration)
                : 0,
            average_repay_term: isSet(object.average_repay_term) ? globalThis.Number(object.average_repay_term) : 0,
            average_pledge_amount: isSet(object.average_pledge_amount) ? globalThis.Number(object.average_pledge_amount) : 0,
            late_term_rate: isSet(object.late_term_rate) ? globalThis.Number(object.late_term_rate) : 0,
            default_term_rate: isSet(object.default_term_rate) ? globalThis.Number(object.default_term_rate) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.project_count !== 0) {
            obj.project_count = Math.round(message.project_count);
        }
        if (message.average_interest_rate !== 0) {
            obj.average_interest_rate = message.average_interest_rate;
        }
        if (message.projects_success_rate !== 0) {
            obj.projects_success_rate = message.projects_success_rate;
        }
        if (message.total_collected_amount !== "0") {
            obj.total_collected_amount = message.total_collected_amount;
        }
        if (message.total_repaid_amount !== 0) {
            obj.total_repaid_amount = message.total_repaid_amount;
        }
        if (message.lenders_count !== 0) {
            obj.lenders_count = Math.round(message.lenders_count);
        }
        if (message.legal_pledges_rate !== 0) {
            obj.legal_pledges_rate = message.legal_pledges_rate;
        }
        if (message.projects_number_by_region) {
            var entries = Object.entries(message.projects_number_by_region);
            if (entries.length > 0) {
                obj.projects_number_by_region = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.projects_number_by_region[k] = Math.round(v);
                });
            }
        }
        if (message.projects_number_by_category) {
            var entries = Object.entries(message.projects_number_by_category);
            if (entries.length > 0) {
                obj.projects_number_by_category = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.projects_number_by_category[k] = Math.round(v);
                });
            }
        }
        if (message.average_collected_amount !== 0) {
            obj.average_collected_amount = message.average_collected_amount;
        }
        if (message.average_collect_duration !== 0) {
            obj.average_collect_duration = message.average_collect_duration;
        }
        if (message.average_repay_term !== 0) {
            obj.average_repay_term = message.average_repay_term;
        }
        if (message.average_pledge_amount !== 0) {
            obj.average_pledge_amount = message.average_pledge_amount;
        }
        if (message.late_term_rate !== 0) {
            obj.late_term_rate = message.late_term_rate;
        }
        if (message.default_term_rate !== 0) {
            obj.default_term_rate = message.default_term_rate;
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var message = createBaseComputeResponse();
        message.project_count = (_a = object.project_count) !== null && _a !== void 0 ? _a : 0;
        message.average_interest_rate = (_b = object.average_interest_rate) !== null && _b !== void 0 ? _b : 0;
        message.projects_success_rate = (_c = object.projects_success_rate) !== null && _c !== void 0 ? _c : 0;
        message.total_collected_amount = (_d = object.total_collected_amount) !== null && _d !== void 0 ? _d : "0";
        message.total_repaid_amount = (_e = object.total_repaid_amount) !== null && _e !== void 0 ? _e : 0;
        message.lenders_count = (_f = object.lenders_count) !== null && _f !== void 0 ? _f : 0;
        message.legal_pledges_rate = (_g = object.legal_pledges_rate) !== null && _g !== void 0 ? _g : 0;
        message.projects_number_by_region = Object.entries((_h = object.projects_number_by_region) !== null && _h !== void 0 ? _h : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.projects_number_by_category = Object.entries((_j = object.projects_number_by_category) !== null && _j !== void 0 ? _j : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.average_collected_amount = (_k = object.average_collected_amount) !== null && _k !== void 0 ? _k : 0;
        message.average_collect_duration = (_l = object.average_collect_duration) !== null && _l !== void 0 ? _l : 0;
        message.average_repay_term = (_m = object.average_repay_term) !== null && _m !== void 0 ? _m : 0;
        message.average_pledge_amount = (_o = object.average_pledge_amount) !== null && _o !== void 0 ? _o : 0;
        message.late_term_rate = (_p = object.late_term_rate) !== null && _p !== void 0 ? _p : 0;
        message.default_term_rate = (_q = object.default_term_rate) !== null && _q !== void 0 ? _q : 0;
        return message;
    },
};
function createBaseComputeResponse_ProjectsNumberByRegionEntry() {
    return { key: "", value: 0 };
}
exports.ComputeResponse_ProjectsNumberByRegionEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeResponse_ProjectsNumberByRegionEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseComputeResponse_ProjectsNumberByRegionEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseComputeResponse_ProjectsNumberByCategoryEntry() {
    return { key: "", value: 0 };
}
exports.ComputeResponse_ProjectsNumberByCategoryEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeResponse_ProjectsNumberByCategoryEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseComputeResponse_ProjectsNumberByCategoryEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllRequest() {
    return { collect_type: collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED, since: undefined, only_fields: {} };
}
exports.AllRequest = {
    fromJSON: function (object) {
        return {
            collect_type: isSet(object.collect_type)
                ? (0, collect_1.collectTypeFromJSON)(object.collect_type)
                : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
            since: isSet(object.since) ? exports.Interval.fromJSON(object.since) : undefined,
            only_fields: isObject(object.only_fields)
                ? Object.entries(object.only_fields).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Boolean(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.collect_type !== collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED) {
            obj.collect_type = (0, collect_1.collectTypeToJSON)(message.collect_type);
        }
        if (message.since !== undefined) {
            obj.since = exports.Interval.toJSON(message.since);
        }
        if (message.only_fields) {
            var entries = Object.entries(message.only_fields);
            if (entries.length > 0) {
                obj.only_fields = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.only_fields[k] = v;
                });
            }
        }
        return obj;
    },
    create: function (base) {
        return exports.AllRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllRequest();
        message.collect_type = (_a = object.collect_type) !== null && _a !== void 0 ? _a : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED;
        message.since = (object.since !== undefined && object.since !== null)
            ? exports.Interval.fromPartial(object.since)
            : undefined;
        message.only_fields = Object.entries((_b = object.only_fields) !== null && _b !== void 0 ? _b : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Boolean(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseAllRequest_OnlyFieldsEntry() {
    return { key: "", value: false };
}
exports.AllRequest_OnlyFieldsEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== false) {
            obj.value = message.value;
        }
        return obj;
    },
    create: function (base) {
        return exports.AllRequest_OnlyFieldsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllRequest_OnlyFieldsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseInterval() {
    return { type: exports.Interval_Type.TYPE_UNSPECIFIED, value: 0 };
}
exports.Interval = {
    fromJSON: function (object) {
        return {
            type: isSet(object.type) ? interval_TypeFromJSON(object.type) : exports.Interval_Type.TYPE_UNSPECIFIED,
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.type !== exports.Interval_Type.TYPE_UNSPECIFIED) {
            obj.type = interval_TypeToJSON(message.type);
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.Interval.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseInterval();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : exports.Interval_Type.TYPE_UNSPECIFIED;
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllResponse() {
    return {
        project_count: 0,
        project_success_rate: 0,
        active_contributor_count: 0,
        collected_amount_sum: "0",
        collected_amount_average: 0,
        collect_duration_average: 0,
        pledge_amount_average: 0,
        legal_pledge_rate: 0,
        contribution_count: 0,
        project_count_by_category: {},
        project_count_by_region: {},
        project_count_by_country: {},
        collected_amount_sum_by_region: {},
        collected_amount_sum_by_country: {},
        collected_amount_sum_by_thematic: {},
        project_count_by_thematic: {},
        xirr_mii_provision_by_thematic: {},
        lending_interest_rate_average: 0,
        lending_repaid_amount_sum: 0,
        lending_repay_term_frequency_average: 0,
        lending_late_term_rate: 0,
        lending_default_term_rate: 0,
    };
}
exports.AllResponse = {
    fromJSON: function (object) {
        return {
            project_count: isSet(object.project_count) ? globalThis.Number(object.project_count) : 0,
            project_success_rate: isSet(object.project_success_rate) ? globalThis.Number(object.project_success_rate) : 0,
            active_contributor_count: isSet(object.active_contributor_count)
                ? globalThis.Number(object.active_contributor_count)
                : 0,
            collected_amount_sum: isSet(object.collected_amount_sum) ? globalThis.String(object.collected_amount_sum) : "0",
            collected_amount_average: isSet(object.collected_amount_average)
                ? globalThis.Number(object.collected_amount_average)
                : 0,
            collect_duration_average: isSet(object.collect_duration_average)
                ? globalThis.Number(object.collect_duration_average)
                : 0,
            pledge_amount_average: isSet(object.pledge_amount_average) ? globalThis.Number(object.pledge_amount_average) : 0,
            legal_pledge_rate: isSet(object.legal_pledge_rate) ? globalThis.Number(object.legal_pledge_rate) : 0,
            contribution_count: isSet(object.contribution_count) ? globalThis.Number(object.contribution_count) : 0,
            project_count_by_category: isObject(object.project_count_by_category)
                ? Object.entries(object.project_count_by_category).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            project_count_by_region: isObject(object.project_count_by_region)
                ? Object.entries(object.project_count_by_region).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            project_count_by_country: isObject(object.project_count_by_country)
                ? Object.entries(object.project_count_by_country).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            collected_amount_sum_by_region: isObject(object.collected_amount_sum_by_region)
                ? Object.entries(object.collected_amount_sum_by_region).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            collected_amount_sum_by_country: isObject(object.collected_amount_sum_by_country)
                ? Object.entries(object.collected_amount_sum_by_country).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            collected_amount_sum_by_thematic: isObject(object.collected_amount_sum_by_thematic)
                ? Object.entries(object.collected_amount_sum_by_thematic).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            project_count_by_thematic: isObject(object.project_count_by_thematic)
                ? Object.entries(object.project_count_by_thematic).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            xirr_mii_provision_by_thematic: isObject(object.xirr_mii_provision_by_thematic)
                ? Object.entries(object.xirr_mii_provision_by_thematic).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            lending_interest_rate_average: isSet(object.lending_interest_rate_average)
                ? globalThis.Number(object.lending_interest_rate_average)
                : 0,
            lending_repaid_amount_sum: isSet(object.lending_repaid_amount_sum)
                ? globalThis.Number(object.lending_repaid_amount_sum)
                : 0,
            lending_repay_term_frequency_average: isSet(object.lending_repay_term_frequency_average)
                ? globalThis.Number(object.lending_repay_term_frequency_average)
                : 0,
            lending_late_term_rate: isSet(object.lending_late_term_rate)
                ? globalThis.Number(object.lending_late_term_rate)
                : 0,
            lending_default_term_rate: isSet(object.lending_default_term_rate)
                ? globalThis.Number(object.lending_default_term_rate)
                : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.project_count !== 0) {
            obj.project_count = Math.round(message.project_count);
        }
        if (message.project_success_rate !== 0) {
            obj.project_success_rate = message.project_success_rate;
        }
        if (message.active_contributor_count !== 0) {
            obj.active_contributor_count = Math.round(message.active_contributor_count);
        }
        if (message.collected_amount_sum !== "0") {
            obj.collected_amount_sum = message.collected_amount_sum;
        }
        if (message.collected_amount_average !== 0) {
            obj.collected_amount_average = message.collected_amount_average;
        }
        if (message.collect_duration_average !== 0) {
            obj.collect_duration_average = message.collect_duration_average;
        }
        if (message.pledge_amount_average !== 0) {
            obj.pledge_amount_average = message.pledge_amount_average;
        }
        if (message.legal_pledge_rate !== 0) {
            obj.legal_pledge_rate = message.legal_pledge_rate;
        }
        if (message.contribution_count !== 0) {
            obj.contribution_count = Math.round(message.contribution_count);
        }
        if (message.project_count_by_category) {
            var entries = Object.entries(message.project_count_by_category);
            if (entries.length > 0) {
                obj.project_count_by_category = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.project_count_by_category[k] = Math.round(v);
                });
            }
        }
        if (message.project_count_by_region) {
            var entries = Object.entries(message.project_count_by_region);
            if (entries.length > 0) {
                obj.project_count_by_region = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.project_count_by_region[k] = Math.round(v);
                });
            }
        }
        if (message.project_count_by_country) {
            var entries = Object.entries(message.project_count_by_country);
            if (entries.length > 0) {
                obj.project_count_by_country = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.project_count_by_country[k] = Math.round(v);
                });
            }
        }
        if (message.collected_amount_sum_by_region) {
            var entries = Object.entries(message.collected_amount_sum_by_region);
            if (entries.length > 0) {
                obj.collected_amount_sum_by_region = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.collected_amount_sum_by_region[k] = Math.round(v);
                });
            }
        }
        if (message.collected_amount_sum_by_country) {
            var entries = Object.entries(message.collected_amount_sum_by_country);
            if (entries.length > 0) {
                obj.collected_amount_sum_by_country = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.collected_amount_sum_by_country[k] = Math.round(v);
                });
            }
        }
        if (message.collected_amount_sum_by_thematic) {
            var entries = Object.entries(message.collected_amount_sum_by_thematic);
            if (entries.length > 0) {
                obj.collected_amount_sum_by_thematic = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.collected_amount_sum_by_thematic[k] = Math.round(v);
                });
            }
        }
        if (message.project_count_by_thematic) {
            var entries = Object.entries(message.project_count_by_thematic);
            if (entries.length > 0) {
                obj.project_count_by_thematic = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.project_count_by_thematic[k] = Math.round(v);
                });
            }
        }
        if (message.xirr_mii_provision_by_thematic) {
            var entries = Object.entries(message.xirr_mii_provision_by_thematic);
            if (entries.length > 0) {
                obj.xirr_mii_provision_by_thematic = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.xirr_mii_provision_by_thematic[k] = v;
                });
            }
        }
        if (message.lending_interest_rate_average !== 0) {
            obj.lending_interest_rate_average = message.lending_interest_rate_average;
        }
        if (message.lending_repaid_amount_sum !== 0) {
            obj.lending_repaid_amount_sum = message.lending_repaid_amount_sum;
        }
        if (message.lending_repay_term_frequency_average !== 0) {
            obj.lending_repay_term_frequency_average = message.lending_repay_term_frequency_average;
        }
        if (message.lending_late_term_rate !== 0) {
            obj.lending_late_term_rate = message.lending_late_term_rate;
        }
        if (message.lending_default_term_rate !== 0) {
            obj.lending_default_term_rate = message.lending_default_term_rate;
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        var message = createBaseAllResponse();
        message.project_count = (_a = object.project_count) !== null && _a !== void 0 ? _a : 0;
        message.project_success_rate = (_b = object.project_success_rate) !== null && _b !== void 0 ? _b : 0;
        message.active_contributor_count = (_c = object.active_contributor_count) !== null && _c !== void 0 ? _c : 0;
        message.collected_amount_sum = (_d = object.collected_amount_sum) !== null && _d !== void 0 ? _d : "0";
        message.collected_amount_average = (_e = object.collected_amount_average) !== null && _e !== void 0 ? _e : 0;
        message.collect_duration_average = (_f = object.collect_duration_average) !== null && _f !== void 0 ? _f : 0;
        message.pledge_amount_average = (_g = object.pledge_amount_average) !== null && _g !== void 0 ? _g : 0;
        message.legal_pledge_rate = (_h = object.legal_pledge_rate) !== null && _h !== void 0 ? _h : 0;
        message.contribution_count = (_j = object.contribution_count) !== null && _j !== void 0 ? _j : 0;
        message.project_count_by_category = Object.entries((_k = object.project_count_by_category) !== null && _k !== void 0 ? _k : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.project_count_by_region = Object.entries((_l = object.project_count_by_region) !== null && _l !== void 0 ? _l : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.project_count_by_country = Object.entries((_m = object.project_count_by_country) !== null && _m !== void 0 ? _m : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.collected_amount_sum_by_region = Object.entries((_o = object.collected_amount_sum_by_region) !== null && _o !== void 0 ? _o : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.collected_amount_sum_by_country = Object.entries((_p = object.collected_amount_sum_by_country) !== null && _p !== void 0 ? _p : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.collected_amount_sum_by_thematic = Object.entries((_q = object.collected_amount_sum_by_thematic) !== null && _q !== void 0 ? _q : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.project_count_by_thematic = Object.entries((_r = object.project_count_by_thematic) !== null && _r !== void 0 ? _r : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.xirr_mii_provision_by_thematic = Object.entries((_s = object.xirr_mii_provision_by_thematic) !== null && _s !== void 0 ? _s : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.lending_interest_rate_average = (_t = object.lending_interest_rate_average) !== null && _t !== void 0 ? _t : 0;
        message.lending_repaid_amount_sum = (_u = object.lending_repaid_amount_sum) !== null && _u !== void 0 ? _u : 0;
        message.lending_repay_term_frequency_average = (_v = object.lending_repay_term_frequency_average) !== null && _v !== void 0 ? _v : 0;
        message.lending_late_term_rate = (_w = object.lending_late_term_rate) !== null && _w !== void 0 ? _w : 0;
        message.lending_default_term_rate = (_x = object.lending_default_term_rate) !== null && _x !== void 0 ? _x : 0;
        return message;
    },
};
function createBaseAllResponse_ProjectCountByCategoryEntry() {
    return { key: "", value: 0 };
}
exports.AllResponse_ProjectCountByCategoryEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse_ProjectCountByCategoryEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllResponse_ProjectCountByCategoryEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllResponse_ProjectCountByRegionEntry() {
    return { key: "", value: 0 };
}
exports.AllResponse_ProjectCountByRegionEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse_ProjectCountByRegionEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllResponse_ProjectCountByRegionEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllResponse_ProjectCountByCountryEntry() {
    return { key: "", value: 0 };
}
exports.AllResponse_ProjectCountByCountryEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse_ProjectCountByCountryEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllResponse_ProjectCountByCountryEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllResponse_CollectedAmountSumByRegionEntry() {
    return { key: "", value: 0 };
}
exports.AllResponse_CollectedAmountSumByRegionEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse_CollectedAmountSumByRegionEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllResponse_CollectedAmountSumByRegionEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllResponse_CollectedAmountSumByCountryEntry() {
    return { key: "", value: 0 };
}
exports.AllResponse_CollectedAmountSumByCountryEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse_CollectedAmountSumByCountryEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllResponse_CollectedAmountSumByCountryEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllResponse_CollectedAmountSumByThematicEntry() {
    return { key: "", value: 0 };
}
exports.AllResponse_CollectedAmountSumByThematicEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse_CollectedAmountSumByThematicEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllResponse_CollectedAmountSumByThematicEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllResponse_ProjectCountByThematicEntry() {
    return { key: "", value: 0 };
}
exports.AllResponse_ProjectCountByThematicEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse_ProjectCountByThematicEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllResponse_ProjectCountByThematicEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAllResponse_XirrMiiProvisionByThematicEntry() {
    return { key: "", value: 0 };
}
exports.AllResponse_XirrMiiProvisionByThematicEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = message.value;
        }
        return obj;
    },
    create: function (base) {
        return exports.AllResponse_XirrMiiProvisionByThematicEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAllResponse_XirrMiiProvisionByThematicEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
function handleRequest(url, requestBody, fromJSON, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseBody, parseError_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] request:\n', JSON.stringify(requestBody));
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: __assign(__assign({ 'Content-Type': 'application/json' }, ((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {})), ((options === null || options === void 0 ? void 0 : options.user_id) ? { 'X-Jwt-Payload-B64': options.user_id } : {}))
                        })];
                case 1:
                    response = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] response:\n', JSON.stringify(response));
                    }
                    responseBody = void 0;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 6]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    parseError_1 = _b.sent();
                    return [4 /*yield*/, response.text()];
                case 5:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!response.ok) {
                        throw {
                            statusText: response.statusText || 'HTTP Error',
                            body: responseBody
                        };
                    }
                    return [2 /*return*/, fromJSON(responseBody)];
                case 7:
                    error_1 = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.error('[CLIENT DEBUG] error:\n', JSON.stringify(error_1));
                    }
                    if (error_1.statusText) {
                        // This is our custom error object from above
                        throw error_1;
                    }
                    else {
                        // This could be a network error or other fetch-related error
                        throw {
                            statusText: 'Network Error',
                            body: error_1.message || 'An unknown error occurred',
                            error: error_1,
                        };
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var StatsServiceClient = /** @class */ (function () {
    function StatsServiceClient(fetcher, baseURL) {
        this.fetcher = fetcher;
        this.baseURL = baseURL;
    }
    StatsServiceClient.prototype.Health = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = health_1.HealthRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.stats.v1.StatsService/Health";
                return [2 /*return*/, handleRequest(url, jsonReq, health_1.HealthResponse.fromJSON, options)];
            });
        });
    };
    StatsServiceClient.prototype.Compute = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ComputeRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.stats.v1.StatsService/Compute";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ComputeResponse.fromJSON, options)];
            });
        });
    };
    StatsServiceClient.prototype.All = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.AllRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.stats.v1.StatsService/All";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.AllResponse.fromJSON, options)];
            });
        });
    };
    return StatsServiceClient;
}());
exports.StatsServiceClient = StatsServiceClient;
//# sourceMappingURL=stats.js.map